<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'
import { notify } from '@/helpers/notify'

export default {
  page: {
    title: "Fatura Makbuz Ara",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [datatableMixin],
  components: { Layout, PageHeader, Datatable },
  data() {
    return {
      title: "FATURA MAKBUZ ARA",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "FATURA MAKBUZ ARA", active: true },
      ],
      columns: [
        { name: 'Durum', key: 'printed', className: 'text-center' },
        { name: 'Müşteri', key: 'fname' },
        { name: 'Kullanıcı', key: 'username' },
        { name: 'Belge No', key: 'nfnum' },
        { name: 'Tarih', key: 'transaction_date' },
        { name: 'Açıklama', key: 'main_explaine' },
        { name: 'Tutar', key: 'amount', className: 'text-end' },
      ],
      tableData: {
        detail: true,
        excel: true,
        searchable: {
          visible: true,
          placeholder: "Müşteri adı veya belge no",
        },
      },
      endpoint: '/get-balances',
      exportName: 'FATURA_MAKBUZ_LISTESI',
      nfnum: {},
      form: { tur: '', startdateend: '', startdate: '' },
    };
  },
  methods: {
    async loadPage() {
      this.params.page === 1 ? this.isLoading = true : this.pageLoading = true
      const response = await this.$http.post(this.endpoint, {
        params: this.params,
        search_params: this.searchParams,
        sort: this.sort,
        search_query: this.searchQuery,
      })
      if (this.params.page === 1) {
        this.tableData.data = response.data.data
      } else {
        this.tableData.data = [...this.tableData.data, ...response.data.data]
      }
      response.data.data.forEach((item) => {
        if (item.invoice_num) this.nfnum[item.id] = item.invoice_num
      })
      this.tableData.pagination = {
        current_page: response.data.current_page,
        last_page: response.data.last_page,
        total: response.data.total,
      }
      this.params.page === 1 ? this.isLoading = false : this.pageLoading = false
    },
    fullname(obj) {
      return obj.fname + ' ' + obj.lname
    },
    amount(obj) {
      return this.$paraFormat(obj.amount)
    },
    faturaNoKaydet(id) {
      this.$http.put('/balances', { invoice_num: this.nfnum[id], id })
        .then((response) => notify.success(response.data.message))
    },
    handleFilterChange() {
      this.searchParams = this.form
      this.params.page = 1
      this.nfnum = {}
      this.tableData.data = []
      this.loadPage()
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="bh">
      <div class="bh-bar">
        <div>
          <span class="bh-kicker">Ön muhasebe</span>
          <h4>Faturalar ve makbuzlar</h4>
        </div>
        <div class="bh-total" v-if="tableData.pagination">
          <span>Kayıt</span>
          <strong>{{ tableData.pagination.total || 0 }}</strong>
        </div>
      </div>

      <div class="bh-filters">
        <div>
          <label>Belge durumu</label>
          <select v-model="form.tur" class="form-select" @change="handleFilterChange">
            <option value="">Tümü</option>
            <option value="basilanlar">Basılanlar</option>
            <option value="makbuz">Makbuz</option>
            <option value="fatura">Fatura</option>
            <option value="basilmayan">Basılmayanlar</option>
            <option value="numaralandirilmayan">Numarasız</option>
            <option value="numaralandirilanlar">Numaralı</option>
          </select>
        </div>
        <div>
          <label class="d-flex justify-content-between">
            Tarih
            <span v-if="form.startdate || form.startdateend" class="bh-clear" @click="form.startdate=''; form.startdateend=''; handleFilterChange()">Temizle</span>
          </label>
          <div class="input-group">
            <input type="date" class="form-control" v-model="form.startdate" @change="handleFilterChange">
            <span class="input-group-text">–</span>
            <input type="date" class="form-control" v-model="form.startdateend" @change="handleFilterChange">
          </div>
        </div>
      </div>

      <div class="bh-card">
        <Datatable
          :columns="columns"
          :tableData="tableData"
          @sort-column="handleSortColumn"
          @search-query="reLoadPage"
          @excel-export="excelExport"
          :loading="isLoading"
          :poading="pageLoading">
          <template #fname="{ row }">
            <div class="bh-customer">
              <strong>{{ fullname(row) }}</strong>
            </div>
          </template>
          <template #amount="{ row }">
            <span :class="row.direction == 1 ? 'bh-in' : 'bh-out'">{{ amount(row) }}</span>
          </template>
          <template #printed="{ row }">
            <span :class="row.printed == 0 ? 'bh-badge bh-badge--wait' : 'bh-badge bh-badge--ok'">
              {{ row.printed == 0 ? 'Basılmadı' : 'Basıldı' }}
            </span>
          </template>
          <template #nfnum="{ row }">
            <div class="input-group input-group-sm">
              <span class="input-group-text">{{ row.direction == 1 ? 'Makbuz' : 'Fatura' }}</span>
              <input type="text" class="form-control form-control-sm" v-model="nfnum[row.id]">
              <button class="btn btn-sm btn-success" type="button" @click="faturaNoKaydet(row.id)">Kaydet</button>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.bh { display: flex; flex-direction: column; gap: 14px; }
.bh-bar, .bh-filters, .bh-card {
  background: #fff;
  border: 1px solid #e6e8ec;
  border-radius: 10px;
}
.bh-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
}
.bh-kicker {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #1f8f4e;
}
.bh-bar h4 { margin: 2px 0 0; font-size: 1.15rem; color: #1f2933; }
.bh-total { text-align: right; }
.bh-total span { display: block; font-size: 11px; color: #7b8794; text-transform: uppercase; letter-spacing: .04em; }
.bh-total strong { font-size: 1.2rem; color: #1f2933; }
.bh-filters {
  display: grid;
  grid-template-columns: 280px 360px;
  gap: 16px;
  padding: 14px 18px;
}
.bh-filters label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #52606d;
}
.bh-clear { color: #d64545; cursor: pointer; font-weight: 500; }
.bh-card { padding: 8px 12px 12px; }
.bh-customer strong { color: #1f2933; font-weight: 600; }
.bh-in { color: #1f8f4e; font-weight: 700; }
.bh-out { color: #c2410c; font-weight: 700; }
.bh-badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}
.bh-badge--ok { background: #e8f7ee; color: #1f8f4e; }
.bh-badge--wait { background: #f4f5f7; color: #52606d; }
@media (max-width: 767.98px) {
  .bh-filters { grid-template-columns: 1fr; }
}
</style>
